const defaultState = {
	showTripsHistory: false,
	tripsGPS: [], // list of GPS coordinates for the clicked trip route
	tripsEvents: [], // list of events for the clicked trip route
	tripsSpeedEvents: [], // list of the speed event subcategories for the clicked trip route LSA, MSA, HSA, SSA
	tripsSpeedEventsFilters: {},
	deviceTrips: [], // list of the device trips once user clicks on the Route History
	selectedTrip: null, // trip which was clicked on the right sidebar and getted from the deviceTrips list
	tripTimelineTimestamp: null, // timestamp clicked on the slider-horizontal of the TRIP REPLAY CONTROLS (like "2022-10-07 16:18:18")
	tripPlaybackTimestamp: null, // timestamp of playback trip on the slider-horizontal of the TRIP REPLAY CONTROLS (like "2022-10-07 16:18:18") once the PLAY clicking
	tripAlertsMarkers: [],
	tripAdvancedPlayerEvent: {}, // it is used to display advanced player on the trip history popup. If it is set then should display the advanced player.
	tripShowShareEvent: {}, // it is used to display share event on the trip history popup. If it is set then should display the share event popup.
	tripShowSnapshotEvent: {}, // it is used to display the snapshot modal from the trip history popup, independent of the event's video upload status. If it is set then should display the snapshot popup.
	selectedDropdownEventId: null, // stores selected event id from the dropdown list of events on the trip card
	tripsGPSSnapRoad: [], // list of GPS coordinates for the clicked trip route are requested via Google Snap to Roads feature. Depends on the tripsGPS coordinates.
	showSnapRoad: false,
	dashboardRedirect: null, // stores needed params when redirecting to the Homepage (from the Unknown Driver Trips popup of Drivers page)
	selectedTripsEventIdToShowPopup: null, // stores selected event id of events for the clicked trip route to show MarkerAlertPopup -- FWSD-4482
	sideMenuOpen: JSON.parse(localStorage.getItem('openState')) === null ? false : JSON.parse(localStorage.getItem('openState')), // true/false should be collapsed/expanded the left sidebar menu
	showNewMapFeedbackModal: false, // show/hide the Feedback modal, FWSD-7380
	renderHomepage: false, // changing of this state rerenders the Homepage and Map there, FWSD-7380,
	vehiclesType: 'vehicle',
	dashboardLoaded: false,
};

const dashboardData = (state = defaultState, action) => {
	switch (action.type) {
		case 'SET_DASHBOARD_REDIRECT': {
			return { ...state, dashboardRedirect: action.payload };
		}
		case 'SET_DEVICE_TRIPS': {
			return { ...state, deviceTrips: action.payload };
		}
		case 'SET_SHOW_TRIP_HISTORY': {
			return { ...state, showTripsHistory: action.payload };
		}
		case "SET_TRIPS_GPS": {
			if (!action.payload?.length) {
				return {
					...state,
					tripsGPS: [],
					tripsEvents: [],
					tripsSpeedEvents: [],
					tripsSpeedEventsFilters: {},
					tripsGPSSnapRoad: [],
					showSnapRoad: false
				};
			}

			const tripsEvents = state.selectedTrip?.events?.map(event => {
				const pos = action.payload[0].polygon.find(
					item => item.timestamp >= `${event.timestamp}+00`
				);
				return pos ? { ...event, position: { lat: pos.lat, lng: pos.lng } } : null;
			}).filter(Boolean) || [];

			const tripsSpeedEvents = state.selectedTrip?.speeding_events?.map(speedEvent => {
				const positions = action.payload[0].polygon.filter(
					item => item.timestamp >= speedEvent.start_ts && item.timestamp <= speedEvent.end_ts
				);
				return positions.length ? { ...speedEvent, positions, active: true } : null;
			}).filter(Boolean) || [];

			const tripsSpeedEventsFilters = state.selectedTrip?.speeding_events?.reduce(
				(acc, speedEvent) => ((acc[speedEvent.event_type] = true), acc), {}
			) || {};

			return {
				...state,
				tripsGPS: [...action.payload],
				tripsEvents,
				tripsSpeedEvents,
				tripsSpeedEventsFilters,
				tripsGPSSnapRoad: [],
				showSnapRoad: false
			};
		}
		case 'ADD_TRIPS_GPS_POLYGON_POINT': {
			const newTripsGPS = [...state.tripsGPS];
			if (newTripsGPS[0]) {
				newTripsGPS[0] = {
					...newTripsGPS[0],
					polygon: [...(newTripsGPS[0].polygon || []), action.payload]
				};
			}
			return { ...state, tripsGPS: newTripsGPS };
		}
		case 'SET_SELECTED_TRIP': {
			//Hides/shows the devices tree --FWSD-4740
			return { ...state, selectedTrip: action.payload };
		}
		case 'SET_TRIP_TIMELINE_TIMESTAMP': {
			return { ...state, tripTimelineTimestamp: action.payload };
		}
		case 'SET_TRIP_PLAYBACK_TIMESTAMP': {
			return { ...state, tripPlaybackTimestamp: action.payload };
		}
		case 'SET_TRIP_ADVANCED_PLAYER_EVENT': {
			return { ...state, tripAdvancedPlayerEvent: action.payload };
		}
		case 'SET_TRIP_SHOW_SHARE_EVENT': {
			return { ...state, tripShowShareEvent: action.payload };
		}
		case 'SET_TRIP_SHOW_SNAPSHOT_EVENT': {
			return { ...state, tripShowSnapshotEvent: action.payload };
		}
		case 'SET_SELECTED_DROPDOWN_EVENT_ID': {
			return { ...state, selectedDropdownEventId: action.payload };
		}
		case 'SET_SELECTED_TRIPS_EVENT_ID_TO_SHOW_POPUP': {
			return { ...state, selectedTripsEventIdToShowPopup: action.payload };
		}
		case 'SET_TRIPS_SPEED_EVENTS_FILTERS': {
			return { ...state, tripsSpeedEventsFilters: action.payload };
		}
		case 'SET_TRIPS_GPS_SNAP_ROAD': {
			return { ...state, tripsGPSSnapRoad: action.payload };
		}
		case 'SET_SHOW_SNAP_ROAD': {
			return { ...state, showSnapRoad: action.payload };
		}
		case 'SET_SIDE_MENU_OPEN': {
			return { ...state, sideMenuOpen: action.payload };
		}
		case 'SET_SHOW_NEW_MAP_FEEDBACK_MODAL': {
			return { ...state, showNewMapFeedbackModal: action.payload };
		}
		case 'SET_RENDER_HOMEPAGE': {
			return { ...state, renderHomepage: action.payload };
		}
		case 'SET_VEHICLES_TYPE': {
			return { ...state, vehiclesType: action.payload };
		}
		case 'SET_DASHBOARD_LOADED': {
			return { ...state, dashboardLoaded: action.payload };
		}
		default:
			return state;
	}
};

export default dashboardData
